import React from 'react';
import { useNotionContext } from '../context';
import { Text } from './text';
export function User(_a) {
    var _b, _c, _d, _e;
    var data = _a.data, block = _a.block;
    var _f = useNotionContext(), recordMap = _f.recordMap, mapImageUrl = _f.mapImageUrl;
    var blockId = String(((_c = (_b = data === null || data === void 0 ? void 0 : data.flat()) === null || _b === void 0 ? void 0 : _b.flat()) === null || _c === void 0 ? void 0 : _c.flat()[2]) || '');
    var fBlock = (_d = recordMap.notion_user[blockId]) === null || _d === void 0 ? void 0 : _d.value;
    if (!data) {
        // if the blockId was not provided, grab the notion
        blockId = block.created_by_id;
        fBlock = (_e = recordMap.notion_user[blockId]) === null || _e === void 0 ? void 0 : _e.value;
    }
    if (!fBlock)
        return React.createElement(Text, { value: data, block: block });
    return (React.createElement("div", { className: 'notion-collection-row-value' },
        React.createElement("div", { className: 'notion-property notion-property-person' },
            React.createElement("img", { src: mapImageUrl(fBlock === null || fBlock === void 0 ? void 0 : fBlock.profile_photo, block), className: 'notion-property-person-image', alt: '' }),
            React.createElement("span", { className: 'notion-property-person-name' }, fBlock === null || fBlock === void 0 ? void 0 : fBlock.name))));
}
//# sourceMappingURL=user.js.map